import React from 'react';

import { CardGiftcard } from '@mui/icons-material';
import { Chip } from '@mui/material';

type GiftRole = 'giver' | 'receiver' | null;

type Props = {
  giftRole?: GiftRole;
};

function getGiftLabel(giftRole: GiftRole): string {
  switch (giftRole) {
    case 'giver':
      return 'Gift (Giver)';
    case 'receiver':
      return 'Gift (Receiver)';
    default:
      return 'Gift';
  }
}

export function GiftOrderChip({ giftRole }: Props) {
  return (
    <Chip
      icon={<CardGiftcard />}
      label={getGiftLabel(giftRole)}
      size="small"
      sx={{
        bgcolor: 'grey.800',
        color: 'white',
        '& .MuiChip-icon': { color: 'white' },
      }}
    />
  );
}
